// extracted by mini-css-extract-plugin
export var actions = "_tv-4";
export var item = "_tv-1";
export var price = "_tv-3";
export var quantity = "_tv-2";
export var table = "_tv-0";